<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer005">
<h1 class="Heading-1" id="_idParaDest-1"><a id="_idTextAnchor000"></a>About the Author</h1>
<p class="Prelims-prose">R. Allen Shoaf, Alumni Professor Emeritus of English at the University of Florida, is the author of more than a dozen books and nearly 100 papers and reviews in literary studies, twice a holder of Fellowships of the National Endowment for the Humanities, Founding Editor of the prize-winning journal <em class="italic">Exemplaria: A Journal of Theory in Medieval and Renaissance Studies</em>—which he edited from 1987 until 2008—and the winner of six teaching awards during his career at UF, including ‘University-Wide Teacher of the Year’ in 1992. He is also the author of several books of poetry, most recently <em class="italic">Pied-Piper Philology: Love Words</em>, and a contributor to poetry magazines. Graduating from Wake Forest University in 1970, later that year, he took up a Marshall Scholarship to study in the United Kingdom (BA Hon., 1972). He has dedicated his career to Chaucer, Shakespeare, and Milton, authoring books and numerous articles on all three poets, and he has also published regularly over the past 40 years in Dante scholarship, especially regarding the relationship between late medieval sign theory and the <span class="CharOverride-1">Commedia. </span><em class="italic">Language to Live In</em> is his fourth book of poems and brings together his recent writings in eroticism, quantum physics, biology, neuroscience, and politics.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781645367314_EPUB.vue?0f0e20da